import { Mails, MessagesSquare } from "lucide-react";
import { ToggleGroup, ToggleGroupItem } from "@/components/shadcn/toggle-group";
import type { MailListView } from "../types";

const OPTIONS: { value: MailListView; label: string; icon: typeof Mails }[] = [
  { value: "conversations", label: "Conversations", icon: MessagesSquare },
  { value: "messages", label: "Messages", icon: Mails },
];

type MailListViewToggleProps = {
  value: MailListView;
  onChange: (value: MailListView) => void;
};

/** Shows the list as conversations, the way mail clients default, or as separate emails. */
export const MailListViewToggle = ({ value, onChange }: MailListViewToggleProps) => (
  <ToggleGroup
    type="single"
    value={value}
    // Radix reports an empty value when the active item is clicked again; keep the selection.
    onValueChange={next => next && onChange(next as MailListView)}
    aria-label="Arrange emails"
    className="flex shrink-0 gap-1 rounded-md bg-gray-100 p-1"
  >
    {OPTIONS.map(({ value: option, label, icon: Icon }) => (
      <ToggleGroupItem
        key={option}
        value={option}
        size="sm"
        aria-label={label}
        title={label}
        className="h-7 min-w-7 px-1.5 hover:bg-kPurple-50 hover:text-kPurple-500 data-[state=on]:bg-kPurple-500 data-[state=on]:text-white data-[state=on]:shadow-sm"
      >
        <Icon />
      </ToggleGroupItem>
    ))}
  </ToggleGroup>
);
